import { createNullableProvideInject } from '@collector/shared-ui'

import { FieldClickCoordinatesIncidentConfig } from '../configuration'

export const [
  provideFieldClickCoordinatesIncidentConfig,
  injectFieldClickCoordinatesIncidentConfig,
] = createNullableProvideInject<FieldClickCoordinatesIncidentConfig>(
  'fieldClickCoordinatesIncidentConfig',
)
